import { AppEntities } from "../../../../config/entities";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";

const PositionList = () => {
    const fields = [
        { title: "Name", fieldName: "name" },
    ];

    return (
        <>
            <CatalogListView fields={fields} entity={AppEntities.Position} >
                <CatalogListViewToolbar>
                    <CatalogListViewDefaultToolbarButtons/>
                </CatalogListViewToolbar>
            </CatalogListView>
        </>
    );
}

export default PositionList;

